import {Box, ButtonBase, Typography} from '@mui/material';
import PropTypes from 'prop-types';

import {FONT_FAMILIES} from '../../../../../../../const';

export const PractitionerItem = ({practitioner, isSelected, isDisabled, showSeparator, onSelect}) => {
  const name = `${practitioner.first_name[0].toUpperCase()}. ${practitioner.last_name}`;

  return (
    <Box display="flex" alignItems="center" data-testid={`practitioner-${practitioner.practitioner_id}`} data-id={`practitioner-${practitioner.practitioner_id}`}>
      <ButtonBase
        disabled={isDisabled}
        onClick={onSelect}
        sx={{
          px: {xs: 0.5, sm: 1.5},
          borderRadius: '20px',
          cursor: isDisabled ? 'not-allowed' : 'pointer'
        }}
      >
        <Typography
          color="#FFF"
          fontFamily={FONT_FAMILIES.TITLE}
          fontSize={11}
          sx={{
            whiteSpace: 'nowrap',
            opacity: isSelected ? 1 : 0.5
          }}
        >
          {name}
        </Typography>
      </ButtonBase>

      {showSeparator && <Box role="separator" sx={{height: '100%', borderRight: '1px solid white', mx: 0.5}} />}
    </Box>
  );
};

PractitionerItem.propTypes = {
  practitioner: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    practitioner_id: PropTypes.string.isRequired
  }).isRequired,
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
  showSeparator: PropTypes.bool,
  onSelect: PropTypes.func.isRequired
};
